module.exports = __webpack_public_path__ + "img/img5.de2bae38.png";